import { createEvent, restore, sample } from 'effector'
import { fx } from '../../../../libs'
import { PermissionRef, User, UserGroupRef } from './types'
import { $params } from '../../../../features/router'
export const userProfileMounted = createEvent()
export const setUserProfile = createEvent<User>()
export const $userProfile = restore(setUserProfile, {
  id: '0',
  firstName: '',
  middleName: '',
  lastName: '',
  email: '',
  position: '',
  verified: false,
  country: '',
  fullName: '',
  hasDeposit: false,
  partner: false,
  banned: false,
  deleted: false,
  registeredAt: '',
  address: '',
  phone: '',
  dateOfBirth: '',
  socialNetwork: '',
  avatarUrl: '',
  gender: '',
  verifications: [],
})

export const getUser = fx<void, User>({
  method: 'GET',
  url: '/user/',
})

export const banUser = fx<User, User>({
  method: 'PUT',
  url: '/user/',
})

export const deleteUser = fx<User, void>({
  method: 'DELETE',
  url: '/user/',
})

const unwrapList = <T,>(body: unknown): T[] => {
  if (Array.isArray(body)) return body as T[]
  if (body && typeof body === 'object' && Array.isArray((body as any).items)) {
    return (body as any).items as T[]
  }
  return []
}

export const getUserGroups = fx<void, UserGroupRef[] | { items: UserGroupRef[] }>({
  method: 'GET',
  url: '/user/{userId}/groups',
})

export const getUserRoles = fx<void, string[]>({
  method: 'GET',
  url: '/user/{userId}/roles',
})

export const getUserEffectivePermissions = fx<
  void,
  PermissionRef[] | { items: PermissionRef[] }
>({
  method: 'GET',
  url: '/permission/by_user/{userId}',
})

export const $userGroups = restore<UserGroupRef[]>(
  getUserGroups.doneData.map((a) => unwrapList<UserGroupRef>(a.body)),
  [],
)

export const $userRoles = restore<string[]>(
  getUserRoles.doneData.map((a) => (Array.isArray(a.body) ? a.body : [])),
  [],
)

export const $userEffectivePermissions = restore<PermissionRef[]>(
  getUserEffectivePermissions.doneData.map((a) =>
    unwrapList<PermissionRef>(a.body),
  ),
  [],
)

sample({
  clock: userProfileMounted,
  source: $params,
  fn: (params) => {
    let id
    if (params) {
      id = params.userID
    }
    return {
      url: `/user/${id}`,
    }
  },
  target: getUser,
})

sample({
  clock: userProfileMounted,
  source: $params,
  fn: (params) => ({ url: `/user/${params?.userID ?? ''}/groups` }),
  target: getUserGroups,
})

sample({
  clock: userProfileMounted,
  source: $params,
  fn: (params) => ({ url: `/user/${params?.userID ?? ''}/roles` }),
  target: getUserRoles,
})

sample({
  clock: userProfileMounted,
  source: $params,
  fn: (params) => ({
    url: `/permission/by_user/${params?.userID ?? ''}`,
  }),
  target: getUserEffectivePermissions,
})

sample({
  clock: getUser.doneData,
  fn: (doneData) => doneData.body,
  target: setUserProfile,
})
